const requestLocationPermission = ({
  latitude,
  setLatitude,
  longitude,
  setLongitude,
}) => {
  navigator.permissions
    .query({ name: "geolocation" })
    .then((permissionStatus) => {
      if (permissionStatus.state === "granted") {
        getLocation({ latitude, setLatitude, longitude, setLongitude });
      } else if (permissionStatus.state === "prompt") {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setLatitude(position.coords.latitude);
            setLongitude(position.coords.longitude);
            //console.log("User location:", { latitude, longitude });
          },
          (error) => {
            console.error("Error getting user location:", error);
          }
        );
      } else {
        console.log("User denied location permission.");
      }
    })
    .catch((error) => {
      console.error("Error checking location permission:", error);
    });
};

const getLocation = ({ latitude, setLatitude, longitude, setLongitude }) => {
  if ("geolocation" in navigator) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLatitude(position.coords.latitude);
        setLongitude(position.coords.longitude);
        //console.log("User location:", { latitude, longitude });
      },
      (error) => {
        console.error("Error getting user location:", error);
      }
    );
  } else {
    console.log("Geolocation is not supported by this browser.");
  }
};

const SwDev = (context) => {
  const { latitude, setLatitude, longitude, setLongitude } = context;

  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.permissions
        .query({ name: "geolocation" })
        .then((permissionStatus) => {
          if (permissionStatus.state === "granted") {
            getLocation({ latitude, setLatitude, longitude, setLongitude });
          } else if (permissionStatus.state === "prompt") {
            requestLocationPermission({
              latitude,
              setLatitude,
              longitude,
              setLongitude,
            });
            permissionStatus.onchange = () => {
              if (permissionStatus.state === "granted") {
                getLocation({ latitude, setLatitude, longitude, setLongitude });
              } else {
                console.log("User denied location permission.");
              }
            };
          } else {
            console.log("User denied location permission.");
          }
        })
        .catch((error) => {
          console.error("Error checking location permission:", error);
        });

      navigator.serviceWorker
        .register("/service-worker.js")
        .then((registration) => {
          console.log("O SW foi registado com o scope:", registration.scope);
        })
        .catch((error) => {
          console.log("Erro ao registar SW:", error);
        });
    });
  }
};

export default SwDev;
